(function ($) {

	var methods = {
		init: function (options) {
			var opts = $.extend({}, $.fn.perso.defaults, options);
			this.addClass("type-" + opts.type);
			this.append('<div class="mounth mounth-0"></div>');

			// Save instance variables using data
			this.data("interval", false);
			this.data("sequence", [1, 2, 4, 2, 5, 4, 3, 4, 2, 5, 4, 3, 4, 2, 5, 4, 3, 4, 2]);
			this.data("current", 0);

			// Make  it talk if required
			if (opts.talk == true) {
				this.perso("talk");
			}
		},
		talk: function () {
			this.perso("shutUp");
			this.data("interval", requestInterval($.proxy(function () {
				var sequence = this.data("sequence");
				var current = this.data("current");
				this.find('.mounth').removeClass("mounth-0 mounth-1 mounth-2 mounth-3 mounth-4 mounth-5 mounth-6").addClass("mounth-" + sequence[this.data("current")]);
				this.data("current", ((current + 1) % sequence.length));
			}, this), 150));
		},
		shutUp: function () {
			if (this.data("interval")) {
				clearRequestInterval(this.data("interval"));
				this.data("interval", false);
			}
			this.find('.mounth').removeClass("mounth-0 mounth-1 mounth-2 mounth-3 mounth-4 mounth-5 mounth-6");
			this.data("current", 0);
		}
	};

	$.fn.perso = function (methodOrOptions) {

		if (methods[methodOrOptions]) {
			return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
			// Default to "init"
			return methods.init.apply(this, arguments);
		} else {
			$.error('Method ' + methodOrOptions + ' does not exist on plugin.');
		}
	};

	// Plugin defaults – added as a property on our plugin function.
	$.fn.perso.defaults = {
		type: 'farmer1',
		talk: true
	};

})(jQuery);